//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.DimensionBuilder.js";
import "../no/SelectNXObjectList.js";
import "../GeometricUtilities/GeometricUtilities.OrientXpressBuilder.js";
import "../no/SelectNXObject.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"ComponentToMove",0,"SelectNXObjectList",0],[1,"DimensionOrientation",0,"GeometricUtilities.OrientXpressBuilder",0],[0,"DimensionOrientationVector",1,"Direction",0],[1,"MeasurementObject",0,"SelectNXObject",0],[0,"OrientationOption",1,0],[1,"OriginObject",0,"SelectNXObject",0],[0,"OriginalDistance",1,0]],[[["face"],"SetFaceToMove",{},1,0]],[]];
SPLM.Features.LinearDimensionBuilder = class extends SPLM.Features.DimensionBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.LinearDimensionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.LinearDimensionBuilder.OrientationOptionType = Object.freeze({
    "OrientXpress" : "OrientXpress", "Vector" : "Vector"});

export default SPLM;